// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__-Nlq6","box":"style_box__Hfdob","active":"style_active__Pn9zZ","title":"style_title__-loP+","item":"style_item__qpMW-"};